export enum Rate {
  None,
  IndirectTime,
  SiteSpecificTime,
  PersonalTime,
  PaymentFactor,
}

export enum SubmitState {
  None,
  Save,
  Close,
}
